import * as Types from '@/typings'

/** 语言种类 */
export type LangType = 'zh-hans-cn' | 'zh-hant-tw' | 'en' | 'zh-hant-hk' | 'ja'

/** 语言 */
export type LanguageType = {
  label: string
  lang: string
  /** 传给后端接口的字段 */
  languageType: LangType
  hidden?: boolean
}

/** 语言 */
export const LANGUAGE: Types.Dict<Omit<LanguageType, 'label'>> = [
  {
    label: 'English',
    lang: 'en',
    languageType: 'en',
  },
  {
    label: '中文繁體（香港）',
    lang: 'zh-HK',
    languageType: 'zh-hant-hk',
  },
  {
    label: '中文繁體（台湾）',
    lang: 'zh-TW',
    languageType: 'zh-hant-tw',
  },
  {
    label: '中文简体',
    lang: 'zh-CN',
    languageType: 'zh-hans-cn',
  },
  {
    label: 'Japaness',
    lang: 'ja',
    languageType: 'ja',
  },
]

export const LANGUAGE_MAP = LANGUAGE.reduce((acc, next) => {
  acc[next.lang] = next
  return acc
}, {} as Record<string, LanguageType>)

/**
 * 批量上传模板文件
 */
export const TPL_URL_LANG = {
  'zh-TW': 'https://cdn.onewarehouse.net/static/1635997159128/GoodsImport-TC.xlsx',
  'zh-CN': 'https://cdn.onewarehouse.net/static/1635996661110/GoodsImport-SC.xlsx',
}
